import { useMemo } from 'react';
import { useTheme, useMediaQuery, Box } from '@mui/material';
import IndexBox from 'components/IndexBox';


export function IndexesCard({ data }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isTablet  = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  const indexes = useMemo(() => [
    {
      title: 'Daily Aircraft',
      index: data.aircraft1day?.avg?.toFixed(1),
      description: 'Aircraft',
      props: [
        { label: 'H', value: data.aircraft1day?.max?.toFixed(0), color: "info.main" },
        { label: 'L', value: data.aircraft1day?.min?.toFixed(0), color: "error.main" },
      ],
    },
    {
      title: 'Daily Flights',
      index: data.flights1day?.avg?.toFixed(0),
      description: 'Flights',
      props: [
        { label: 'H', value: data.flights1day?.max?.toFixed(0), color: "info.main" },
        { label: 'L', value: data.flights1day?.min?.toFixed(0), color: "error.main" },
      ],
    },
    {
      title: 'BH per Flight',
      index: data.blockHours1flight?.avg?.toFixed(2),
      description: 'Hours',
      props: [
        { label: 'H', value: data.blockHours1flight?.max?.toFixed(2), color: "info.main" },
        { label: 'L', value: data.blockHours1flight?.min?.toFixed(2), color: "error.main" },
      ],
    },
    {
      title: 'Pax per Flight',
      index: data.pax1flight?.avg?.toFixed(0),
      description: 'Pax',
      props: [
        { label: 'H', value: data.pax1flight?.max?.toFixed(0), color: "info.main" },
        { label: 'L', value: data.pax1flight?.min?.toFixed(0), color: "error.main" },
      ],
    },
    {
      title: 'Dep OTP',
      index: data.depOTP1day?.avg?.toFixed(1),
      description: 'Percent',
      props: [
        { label: 'H', value: data.depOTP1day?.max?.toFixed(0), color: "info.main" },
        { label: 'L', value: data.depOTP1day?.min?.toFixed(0), color: "error.main" },
      ],
    },
    {
      title: 'Arr OTP',
      index: data.arrOTP1day?.avg?.toFixed(1),
      description: 'Percent',
      props: [
        { label: 'H', value: data.arrOTP1day?.max?.toFixed(0), color: "info.main" },
        { label: 'L', value: data.arrOTP1day?.min?.toFixed(0), color: "error.main" },
      ],
    },
    {
      title: 'Dep Delays',
      index: data.depDelaysTime?.avg?.toFixed(0),
      description: 'Minutes',
      props: [
        { label: 'H', value: data.depDelaysTime?.max?.toFixed(0), color: "error.main" },
        { label: 'L', value: data.depDelaysTime?.min?.toFixed(0), color: "info.main" },
      ],
    },
    {
      title: 'Arr Delays',
      index: data.arrDelaysTime?.avg?.toFixed(0),
      description: 'Minutes',
      props: [
        { label: 'H', value: data.arrDelaysTime?.max?.toFixed(0), color: "error.main" },
        { label: 'L', value: data.arrDelaysTime?.min?.toFixed(0), color: "info.main" },
      ],
    },
    {
      title: 'Schedule TAT',
      index: data.scheduleTat?.avg?.toFixed(0),
      description: 'Minutes',
      props: [
        { label: 'H', value: data.scheduleTat?.max?.toFixed(0), color: "error.main" },
        { label: 'L', value: data.scheduleTat?.min?.toFixed(0), color: "info.main" },
      ],
    },
    {
      title: 'Actual TAT',
      index: data.tat?.avg?.toFixed(0),
      description: 'Minutes',
      props: [
        { label: 'H', value: data.tat?.max?.toFixed(0), color: "error.main" },
        { label: 'L', value: data.tat?.min?.toFixed(0), color: "info.main" },
      ],
    },
    {
      title: 'Taxi Out',
      index: data.taxiOut?.avg?.toFixed(0),
      description: 'Minutes',
      props: [
        { label: 'H', value: data.taxiOut?.max?.toFixed(0), color: "error.main" },
        { label: 'L', value: data.taxiOut?.min?.toFixed(0), color: "info.main" },
      ],
    },
    {
      title: 'Taxi In',
      index: data.taxiIn?.avg?.toFixed(0),
      description: 'Minutes',
      props: [
        { label: 'H', value: data.taxiIn?.max?.toFixed(0), color: "error.main" },
        { label: 'L', value: data.taxiIn?.min?.toFixed(0), color: "info.main" },
      ],
    },
  ], [data]);

  return (
    <Box
      id="indexes"
      component="section"
      display="grid"
      gridTemplateColumns={
        isDesktop ? "repeat(6, 1fr)"
        : isTablet  ? "repeat(4, 1fr)"
        : "repeat(2, 1fr)"
      }
      gap={2}
      p={0.5}
    >
      {indexes.map((item, i) => (
        <IndexBox
          key={i}
          title={item.title}
          index={item.index}
          description={item.description}
          props={item.props}
        />
      ))}
    </Box>
  );
}
